import { render, staticRenderFns } from "./headerBanner.vue?vue&type=template&id=a8a4bdfa&scoped=true&"
import script from "./headerBanner.vue?vue&type=script&lang=js&"
export * from "./headerBanner.vue?vue&type=script&lang=js&"
import style0 from "./headerBanner.vue?vue&type=style&index=0&id=a8a4bdfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a4bdfa",
  null
  
)

export default component.exports